import { getDateTimeFromString } from "./Utilities";

export const saveCartToStorage = (data) => {
    localStorage.setItem('cart', JSON.stringify(data));
}

export const loadCartFromStorage = () => {
    return JSON.parse(localStorage.getItem('cart'));
}

export const isCartProductExpired = (product) =>{
    const type = product.type;
    const now = new Date();
    let isExpired = false;

    switch(type) {
        case 'rca':
            const expiresAt = getDateTimeFromString(product.expiresAt);
            isExpired = ( now > expiresAt) ? true: false;
            break;
            
    }
    return isExpired;
}

export const getDeliveryAddressFromRCA = (vehicle) =>{
    const {address, owner} = vehicle;

    let addressName = `Str. ${address.strada}`;
    if (address.nrStrada != '') addressName += ` nr. ${address.nrStrada}`;
    if (address.bloc != '') addressName += `, Bloc ${address.bloc}`;
    if (address.scara != '') addressName += `, Scara ${address.scara}`;
    if (address.etaj != '') addressName += `, Etaj ${address.etaj}`;
    if (address.apartament != '') addressName += `, Ap. ${address.apartament}`;

    return  {
        county: address.Judet.name,
        city: address.Localitate.name,
        phone: owner.Telefon,
        address: addressName,
        postal_code: address.cod_postal,
        fname: owner.Prenume,
        lname: owner.Nume,
    };
}

export const getDeliveryAddressFromAccount = (user) =>{
    return  {
        county: user.county ? user.county : '',
        city: user.city ? user.city : '',
        phone: user.phone ? user.phone : '',
        address: '',
        postal_code: '',
        fname: user.firstName ? user.firstName : '',
        lname: user.lastName ? user.lastName : '',
    };
}

export const totalProductValue = (cart) =>{
    const total = cart.reduce( (total, item) =>{
        return item.type == 'rca' ?
        total + parseFloat(Number(item.prima).toFixed(2)) :
        total
    }, 0
     );
    return Number(total).toFixed(2);
}

export const productsOrderApi = (cart) =>{
    const products = cart.map( p =>{
        let res;
        switch( p.type) {
            case 'rca':
                res = {
                    type: p.type,
                    identificator_oferta: p.identificator_oferta,
                    id: p.id,
                };
                break;
            default:
                res = p;
                break;
        }
        return res;
    });
    return products;
}
